function hasLosFromPosition({ range, fromPosition, targetPosition, allUnits, hexProperties, rules, }) {
    if (hexProperties.getDistance(fromPosition, targetPosition) > range) {
        return false;
    }
    if (rules.isLosUnobstructed(fromPosition, targetPosition, allUnits)) {
        return true;
    }
    return false;
}
export default hasLosFromPosition;
